import React from 'react';
import { useNavigate } from 'react-router-dom';
import EngagementHotspot from '../components/hotspots/EngagementHotspot';
import SpaHotspot from '../components/hotspots/SpaHotspot';
import HotelMapHotspot from '../components/hotspots/HotelMapHotspot';
import DiningMapHotspot from '../components/hotspots/DiningMapHotspot';
import GasStationHotspot from '../components/hotspots/GasStationHotspot';
import CasinoMapHotspot from '../components/hotspots/CasinoMapHotspot';
import ConferenceHotspot from '../components/hotspots/ConferenceHotspot';
import GolfMapHotspot from '../components/hotspots/GolfMapHotspot';
import TheatreHotspot from '../components/hotspots/TheatreHotspot';
import ConnectionHotspot from '../components/hotspots/ConnectionHotspot';

function Home() {
  const navigate = useNavigate();

  return (
    <div className="page splash landingPage">
      <div className="home-map">
        <div className="engagement">
          <EngagementHotspot onClick={() => navigate('/engagement')} />
        </div>
        <div className="spa">
          <SpaHotspot onClick={() => navigate('/spa')} />
        </div>
        <div className="hotel">
          <HotelMapHotspot onClick={() => navigate('/hotel')} />
        </div>
        <div className="dining">
          <DiningMapHotspot onClick={() => navigate('/dining')} />
        </div>
        <div className="gas-station">
          <GasStationHotspot onClick={() => navigate('/gas-station')} />
        </div>
        <div className="casino">
          <CasinoMapHotspot onClick={() => navigate('/casino')} />
        </div>
        <div className="conference">
          <ConferenceHotspot onClick={() => navigate('/conference')} />
        </div>
        <div className="golf">
          <GolfMapHotspot onClick={() => navigate('/golf')} />
        </div>
        <div className="theatre">
          <TheatreHotspot onClick={() => navigate('/theatre')} />
        </div>
        <div className="continuous">
          <ConnectionHotspot onClick={() => navigate('/connection')} />
        </div>
      </div>

      <div className="logo" onClick={() => navigate('/aboutus')}>
        <img src="/assets/casino/Agilysys-Logo.svg" alt="Agilysys" style={{width:'100%', height:'auto'}} />
      </div>

      <div className="top-left">
        <div className="topic-header">
          Maximize Return on Experience
          <div className="sub-topic-header">For Casino Resorts</div>
        </div>
        <div className="column">
          <div className="row"><span>Delight </span>Patrons</div>
          <div className="row"><span>Retain </span>Staff</div>
          <div className="row"><span>Grow </span>Margins</div>
          <div className="line">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="144" viewBox="0 0 8 144" fill="none">
              <path d="M4 4L4 140" stroke="#84BD00" strokeWidth="7" strokeLinecap="round"/>
            </svg>
          </div>
        </div>
      </div>

      <div className="bottom-left">
        <img className="touch-prompt" src="/assets/casino/solutions/Blue-Touch-Icon.gif" alt="" />
        <div className="block">
          Explore our interactive{'\n'}
          Casino Resort map to discover{'\n'}
          where <span>personal</span> meets <span>profitable</span>{'\n'}
          <strong>Touch an area to begin!</strong>
        </div>
      </div>
    </div>
  );
}

export default Home;
